import { revertDeviceModel } from '@/shared/lib';
import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { RmaDevicesQuery, RmaDevicesQueryVariables } from '@/shared/api';
import RMA_DEVICES_QUERY from '../queries/rmaDevices';

/**
 * Loads the devices in the RMA workflow for the call-center device list. Deep-clones the filter and rewrites its model to the legacy identifier, queries RMA_DEVICES_QUERY with the filter and page limit, and throws the first GraphQL error message when no devices came back.
 *
 * @param filter - Filter criteria, whose model is converted to its legacy name.
 * @param limit - Maximum number of records to return.
 * @returns Promise resolving to the RMA devices.
 */
const fetchRmaDevices = async (
  filter: RmaDevicesQueryVariables['filter'],
  limit = 10,
): Promise<RmaDevicesQuery['callCenterDevices']> => {
  const client = createClient();
  const clonedFilter = _.cloneDeep(filter);
  if (!_.isEmpty(clonedFilter)) {
    clonedFilter.model = revertDeviceModel(clonedFilter.model);
  }
  const result = await client.query<RmaDevicesQuery, RmaDevicesQueryVariables>({
    query: RMA_DEVICES_QUERY,
    variables: {
      filter: clonedFilter,
      limit,
    },
  });
  const { data, errors } = result;
  const { callCenterDevices } = data;
  if (_.isNil(callCenterDevices) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return callCenterDevices;
};

export default fetchRmaDevices;
